module.exports = __webpack_public_path__ + "static/media/31_A.c5101573.png";